// extracted by mini-css-extract-plugin
export default {"layout":"FreeSpin2BonusGamesPopup__layout--2Em","game":"FreeSpin2BonusGamesPopup__game--2jG","btn":"FreeSpin2BonusGamesPopup__btn--1Ea"};